<template>
	<div>
		
	</div>
</template>

<script>
	import {
		index
	} from '@/api/dashboard'
	import Qs from 'qs'
	export default {
		name: 'Dashboard',
		data() {
			return {
				pending: {
					
				},
				total: {
					
				},
				role:'',
				hzs_data:{
					
				}
			}
		},
		created() {
			this.getData();
		},
		methods: {
			resetSearch(){
				this.getData();
			},
			getData() {
				index(Qs.stringify()).then(response => {
					let r = response.result;
					this.pending = r.pending;
					this.total = r.total;
					this.role = r.role;
					this.hzs_data = r.hzs_data;
				})
			},
			hrefTo(url) {
				//路由跳转
				this.$router.push({
					path: url,
				});
			},
		}
	}
</script>
